import React, { useState, useRef, useEffect } from "react";
import "./css/multi-select-dropdown.css"; // Reuse existing CSS

const 
SingleSelectDropdown = ({
  label,
  options,
  required,
  setSelectedOption = () => {},
  selectedOption = "",
  handleSelect,
  isError,
  errorMessage,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
    setIsActive(true);
  };

  const handleClear = (e) => {
    e.stopPropagation();
    setSelectedOption("");
    handleSelect?.("");
  };

  useEffect(() => {
    if (!selectedOption) {
      setIsActive(false);
    }
  }, [selectedOption]);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        if (!selectedOption) setIsActive(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [selectedOption]);

  return (
    <div ref={dropdownRef} className={`pre-booking-multi-select-wrapper`}>
      <div
        className={`pre-booking-multi-select-input ${
          isError && "error-border"
        } ${isOpen ? "change-border-color-select" : ""}`}
        onClick={toggleDropdown}
      >
        {label && (
          <label
            className={`pre-booking-multi-select-label ${
              isOpen ? "change-label-color" : ""
            } ${isError ? "error-label" : ""}`}
          >
            {label} {required && <span className="required">*</span>}
          </label>
        )}
        <div
          className={`pre-booking-selected-container ${
            isActive ? "dropdown-active" : ""
          }`}
        >
          {selectedOption && selectedOption !== "" ? (
            <span className="pre-booking-selected-item-single">
              {selectedOption}
            </span>
          ) : (
            <span
              className={`pre-booking-placeholder-text ${
                isActive ? "dropdown-active" : ""
              }`}
            >
              {label ?? "Select Option"}...
            </span>
          )}
        </div>

        {selectedOption && (
          <button
            className={`pre-booking-clear-btn ${
              isActive ? "dropdown-cancel-active" : ""
            }`}
            onClick={handleClear}
          >
            Clear
          </button>
        )}

        <button className="pre-booking-toggle-btn">{isOpen ? "▲" : "▼"}</button>
      </div>
      {isError && <p className="pre-booking-error-message">{errorMessage}</p>}

      {isOpen && (
        <div
          className={`pre-booking-dropdown-list ${
            isActive ? "dropdown-active" : ""
          }`}
        >
          {options.map((option, index) => (
            <div
              key={index}
              className="pre-booking-dropdown-item"
              onClick={() => {
                setSelectedOption(option);
                // handleSelect?.(option);
                setIsOpen(false);
              }}
            >
              {option}
              {selectedOption === option && (
                <span className="check-mark">✓</span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SingleSelectDropdown;
